import { observable, action } from "mobx";
import axios from "axios";

export default class TituloPaginaStore {

    @observable titulo;
    @observable botoesMobile;


    constructor() {
        this.nome = "";
        this.botoesMobile = [];
    }

    setTitulo(value) {
        this.titulo = value;
    }

    setBotoesMobile(value) {
        this.botoesMobile = value;
    }
}
